export default __webpack_public_path__ + "static/media/G_D_btn__Archivio_Roll.8d2cc1b9.svg";